import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import {
  resetAteListAction,
  resetCurrentsAteAction,
} from 'store/actions/layers';
import {
  needUpdateAction,
  resetStatSelectsAction,
  setBackdropLoadingAction,
  toggleOpenClusterModalAction,
} from 'store/actions/mainPage';
import {
  getClusterInfoAction,
  getSearchListsAction,
  langUpdateMultipleAteActionBE,
  resetBusinessEntityDataAction,
  resetClusterInfoAction,
  resetPointsAction,
  setAllPointsAction,
} from 'store/actions/searchTab';
import { resetDynamicSeries } from 'store/actions/dynamicSeries';
import { searchCompanies } from 'components/SearchTab/constants';
import { ListActivities } from 'components/SearchTab/ListActivities';
import { ListLegalForms } from 'components/SearchTab/ListLegalForms';
import { SearchInput } from 'components/SearchTab/SearchInput';
import { SearchMultipleAteBlock } from '../SearchMultipleAteBlock';

export const BusinessEntityBlock: React.FC = () => {
  const { lang, needUpdate, isLogged, currentAteCities, currentAteRegions } =
    useAppSelector((state) => state.mainPage);

  const {
    searchRequest,
    currentActivity,
    currentLegalForm,
    foundPoints,
    clusterInfo,
  } = useAppSelector((state) => state.searchTab);
  const dispatch = useAppDispatch();

  const search = (resetClusterInfo?: boolean) => {
    if (resetClusterInfo) {
      dispatch(resetClusterInfoAction());
    }
    dispatch(resetPointsAction());

    const ateRegions = currentAteRegions.map((ate) => {
      return `${ate.id}_${ate.type}`;
    });

    const ateCities = currentAteCities.map((ate) => {
      return `${ate.id}_${ate.type}`;
    });

    dispatch(setBackdropLoadingAction(true));
    searchCompanies(
      lang,
      searchRequest,
      currentLegalForm,
      currentActivity,
      ateRegions,
      ateCities,
      isLogged
    )
      .then((data) => {
        dispatch(setAllPointsAction(data));
      })
      .finally(() => {
        dispatch(setBackdropLoadingAction(false));
      });
  };

  useEffect(() => {
    if (!needUpdate) return;

    (async () => {
      await dispatch(getSearchListsAction(lang));
      await dispatch(
        langUpdateMultipleAteActionBE(currentAteRegions, currentAteCities)
      );
      if (foundPoints.length) search();
      if (clusterInfo.info)
        dispatch(
          getClusterInfoAction(clusterInfo.gid, clusterInfo.coordinates)
        );
    })();

    dispatch(toggleOpenClusterModalAction(false));
  }, [needUpdate]);

  useEffect(() => {
    dispatch(needUpdateAction(true));

    return () => {
      dispatch(resetBusinessEntityDataAction());
      dispatch(resetClusterInfoAction());
      dispatch(resetCurrentsAteAction());
      dispatch(resetStatSelectsAction());
      dispatch(resetAteListAction('ateCities', 'currAteCity')); //reset layers select options
      dispatch(resetAteListAction('ateVC', 'currAteVC'));
      dispatch(resetDynamicSeries());
    };
  }, []);

  return (
    <>
      <ListLegalForms />
      <ListActivities />
      <SearchMultipleAteBlock />
      <SearchInput search={() => search(true)} />
    </>
  );
};
